// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3M2uc","dragIcon":"Choice_dragIcon__1wJPZ","left":"Choice_left__38XTF","input":"Choice_input__TAo9A"};